export const isExpired = (date: Date): boolean => {
    const currentDate = new Date();
    return currentDate > date;
};
